// Shared axios request config for API clients whose 403s must surface INLINE (via each thunk's
// mutation-error slice) instead of triggering the global "page will be reloaded" forbidden
// interceptor. Used by the margin-center clients — their GETs degrade to seed defaults and their
// writes render the server message next to the control that failed.
export const SKIP_FORBIDDEN = { skipResponseInterceptor: { forbiddenError: true } };
